import React from "react";

export const GlobalSearch = ({ value, setValue, className = "w-28 border border-main rounded-full h-8 px-2 focus:outline-green" }: any) => {
  return (
    <div>
        <input
          className={className}
          placeholder="Search"
          value={value || ""}
          onChange={setValue}
        />
    </div>
  );
};
